<template>
  <div
    class="button d-flex flex-column align-center justify-center"
    style="padding: 7px"
  >
    <div
      :style="cssVars"
      @click="prueba()"
      class="button d-flex flex-column justify-center"
    >
      <v-icon v-text="icon" :style="`font-size:${fontSize}`"></v-icon>
      <div id="vueRoot" v-show="false">
        <form :action="urlAction" ref="form" method="post" target="_blank">
          <div v-for="(item, index) in formData" :key="index">
            <input :name="item.nombreVariable" :value="item.valorVariable" />
          </div>
        </form>
      </div>
    </div>
    <div class="title" v-text="titleButtom"></div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "IconButton",
  components: {},
  props: {
    titleButtom: String,
    backgroundColor: String,
    heightButton: String,
    icon: String,
    fontSize: String,
    widthButton: String,
    parametros: Object,
    urlAction: String,
  },
  data() {
    return {
      name: "iconButton",
    };
  },
  methods: {
    actionButton: function (event) {
      alert("haz presionado el boton" + this.name);
    },

    prueba() {
      console.log("accion del boton");

      this.$refs.form.submit();
    },
  },
  computed: {
    formData() {
      let arregloNuevo = [];

      let keyNames = Object.keys(this.parametros);
      for (let index = 0, n = keyNames.length; index < n; index++) {
        let value = keyNames[index];
        arregloNuevo[index] = {
          nombreVariable: keyNames[index],
          valorVariable: this.parametros[value],
        };
      }
      return arregloNuevo;
    },
    cssVars() {
      return {
        "--bg-color": this.backgroundColor,
        "--height": this.heightButton,
        "--width": this.widthButton,
      };
    },
  },
};
</script>

<style scoped>
.button {
  background: var(--bg-color) !important;
  height: var(--height) !important;
  width: var(--width) !important;
  border-radius: 5px;
  cursor: pointer;
  opacity: 0.5 !important;
  transition: 0.3s;
}

.button:hover {
  opacity: 1 !important;
}

.title {
  font-size: 0.8rem !important;
  font-weight: 300 !important;
}
</style>
